import moment from "moment";

export const PregnancyCalculate = (lastMenstrualPeriodDate?: string) => {
  if (!lastMenstrualPeriodDate) {
    return {
      weeks: undefined,
      days: undefined,
      totalDays: undefined,
      expectedDateOfBirth: null,
      formatted: "0 weeks",
    };
  }

  const lmp = moment(lastMenstrualPeriodDate, "DD-MM-YYYY", true);

  if (!lmp.isValid() || lmp.isAfter(moment(), "day")) {
    return {
      weeks: undefined,
      days: undefined,
      totalDays: undefined,
      expectedDateOfBirth: null,
      formatted: "0 weeks",
    };
  }

  const today = moment().startOf("day");

  // Gestational age
  const totalDays = today.diff(lmp, "days");
  const weeks = Math.floor(totalDays / 7) ?? undefined;
  const days = totalDays % 7;

  // Estimated Due Date = LMP + 280 days (40 weeks)
  const expectedDateOfBirth = lmp.clone().add(280, "days").locale("en");

  return {
    weeks,
    days,
    totalDays,
    estimatedDueDate: expectedDateOfBirth.locale("en").format("DD-MM-YYYY"),
    formatted: `${weeks} weeks${days ? `, ${days} days` : ""}`,
  };
};